import { translate } from './i18n';

// Thin fetch wrapper. Throws Error(message) with .status and .data on failure.
// Server messages are in English; translate() shows them in Arabic when a translation exists.
export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(path, {
    method,
    headers: body !== undefined ? { 'Content-Type': 'application/json' } : {},
    body: body !== undefined ? JSON.stringify(body) : undefined,
    credentials: 'same-origin',
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw Object.assign(new Error(translate(data.error) || translate('Request failed ({status})', { status: res.status })), { status: res.status, data });
  return data;
}

export async function uploadImages(files) {
  const fd = new FormData();
  [...files].forEach((f) => fd.append('images', f));
  const res = await fetch('/api/admin/upload', { method: 'POST', body: fd, credentials: 'same-origin' });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(translate(data.error || 'Upload failed'));
  return data.urls;
}
